export function identity<I, O>(arg: I): O {
  return arg as unknown as O;
}
